import Typography from "@mui/material/Typography";

export function SearchInProgressLabel() {
  return (
    <Typography variant="body2" color="GrayText">
      Searching...
    </Typography>
  );
}
